import React from 'react';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Icon,
  Spacer,
  Text,
  useDisclosure,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import AddInsuranceModalExtractionModal from '@advisory-report/src/features/creation-flow/components/insurance-policies/shared/modal/insurance-form/AddInsuranceModalExtractionModal';
import { InsurancePolicyType } from '@advisory-report/src/types/AdvisoryReport';

interface Props {
  type: InsurancePolicyType;
}
const AddInsuranceModalInsuranceExtractionAlert: React.FC<Props> = ({
  type,
}) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {isOpen && (
        <AddInsuranceModalExtractionModal
          type={type}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
      <Alert variant="ai" alignItems="start">
        <Icon name="RiskAnalysisGeneralRiskAnalysis" />
        <VStack ml="3" align="flex-start">
          <AlertTitle>
            <Text textStyle="normalBodyMedium">
              {t('INSURANCE-POLICIES_MODAL_ALERT_DOC-EXTRACT_TITLE')}
            </Text>
          </AlertTitle>
          <AlertDescription>
            <Text textStyle="smallBody">
              {t('INSURANCE-POLICIES_MODAL_ALERT_DOC-EXTRACT_DESCRIPTION')}
            </Text>
          </AlertDescription>
        </VStack>
        <Spacer />
        <Button variant="ai" onClick={onOpen}>
          {t('INSURANCE-POLICIES_MODAL_ALERT_DOC-EXTRACT_BUTTON')}
        </Button>
      </Alert>
    </>
  );
};

export default AddInsuranceModalInsuranceExtractionAlert;
